import { TileConcreteDisplayProps } from './TileAbstractDisplay.js';
import { CanvasSquareRenderer } from '../renderers/CanvasSquareRenderer.js';

export const CanvasSquareDisplay = (props: TileConcreteDisplayProps) => {
  const {
    center: { x, y },
    fillColor,
    width,
    radius,
    value,
    name,
    truncationMode,
    showLabels,
  } = props;
  const halfWidth = width / 2;

  return (
    <CanvasSquareRenderer
      x={x - halfWidth}
      y={y - halfWidth}
      width={width}
      fillColor={fillColor}
      radius={radius}
      name={name}
      value={value}
      strokeColor="transparent"
      truncationMode={truncationMode}
      showLabels={showLabels}
    />
  );
};

CanvasSquareDisplay['displayName'] = 'CanvasSquareDisplay';
